import { Arrow } from '@radix-ui/react-popover';

export type PopoverArrowProps = React.ComponentPropsWithoutRef<typeof Arrow>;

const PopoverArrow = Arrow;

export default PopoverArrow;
